// types/myOfferProductsTypes.ts
export const EXPORTER_OFFER_PRODUCTS_TYPES = {
  CREATE_EXPORTER_OFFER_PRODUCT: 'Create_exporter_offer-product',
  CREATE_EXPORTER_OFFER_PRODUCT_SUCCESS: 'Create_exporter_offer_product_success',
  GET_EXPORTER_PRODUCT_BY_ID_SUCCESS: 'get_exporter_product_by_id_success',
  GET_EXPORTER_OFFER_PRODUCTS_LIST: 'get_exporter_offer_products_list',
  GET_EXPORTER_OFFER_PRODUCTS_LIST_SUCCESS: 'get_exporter__offer_products_list_success',
  GET_EXPORTER_OFFER_PRODUCTS_LIST_FAILURE: 'get_exporter_offer_products_list_failure',
  GET_OFFER_PRODUCTS_LIST_BUYER: 'get_offer_products_list_buyer',
  GET_OFFER_PRODUCTS_LIST_BUYER_SUCCESS: 'get_offer_products_list_buyer_success',
  GET_OFFER_PRODUCTS_LIST_BUYER_FAILURE: 'get_offer_products_list_buyer_failure',
  DELETE_EXPORTER_OFFER_PRODUCT:'delete_exporter_offer_product',
  DELETE_EXPORTER_OFFER_PRODUCT_SUCCESS:'delete_exporter_offer_product_success',
  GET_EXPORTER_OFFER_PRODUCT_BY_ID: 'get_exporter_product_by_id',
  GET_EXPORTER_OFFER_PRODUCT_BY_ID_SUCCESS: 'get_exporter_product_by_id_success',
  GET_BUYER_OFFER_PRODUCT_BY_ID: 'get_buyer_offer_product_by_id',
  GET_BUYER_OFFER_PRODUCT_BY_ID_SUCCESS: 'get_buyer_offer_product_by_id_success',
  GET_BUYER_OFFER_PRODUCT_BY_ID_FAILURE: 'get_buyer_offer_product_by_id_failure',
};